import React from "react";

import type { PipelineStage } from "../types/dashboard.types";

interface DashboardPipelineTrackerProps {
  stages: PipelineStage[];
}

export const DashboardPipelineTracker: React.FC<
  DashboardPipelineTrackerProps
> = ({ stages }) => {
  return (
    <div className="innovation-dashboard__tracker">
      {stages.map((stage, index) => (
        <React.Fragment key={stage.key}>
          <div className="innovation-dashboard__tracker-card">
            <div className="innovation-dashboard__tracker-label">
              <span
                className="innovation-dashboard__tracker-dot"
                style={{ backgroundColor: stage.dotColor }}
              />
              <span>{stage.label}</span>
            </div>
            <div className="innovation-dashboard__tracker-value">{stage.count}</div>
          </div>
          {index < stages.length - 1 ? (
            <div className="innovation-dashboard__tracker-arrow" aria-hidden="true">
              &gt;
            </div>
          ) : null}
        </React.Fragment>
      ))}
    </div>
  );
};
